import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import fr from 'facet-rest';
import { hasRelationship } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { ScheduledCashJournalSetupStepContent } from './Content/ScheduledCashJournalSetupStepContent';
import ScheduledCashJournalOverride from './metaOverrideSet';

const ScheduledCashJournalSetupStep = ({ className, resource }) => {
  const [fullLiquidation, setFullLiquidation] = useState(resource.attr('fullLiquidation'));
  const history = useHistory();
  const { loadPageContentLink } = usePageContentContext();

  const onClose = async () => {
    if (hasRelationship(resource, fr.relationships.redirectOnClose.name)) {
      await loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      history.push('/');
    }
  };

  const onChange = (attr, value) => {
    if (attr === 'fullLiquidation') {
      setFullLiquidation(value);
    }
  };

  const hasRedirect = hasRelationship(resource, fr.relationships.redirect.name);
  const hasNext = resource.meta().canPost();

  const onNext = async () => {
    await loadPageContentLink(resource.relationship(fr.relationships.redirect.name).link('related'));
  };

  return (
    <WizardStepWrapperTemplate
      submitConfirmation={fullLiquidation === 'true'}
      submitConfirmationTitle={resource?.attr('fullLiquidationConfirmationTitle')}
      submitConfirmationMessage={resource?.attr('fullLiquidationConfirmationMessage')}
      submitConfirmationButtonLabel={resource?.attr('fullLiquidationConfirmationPrimaryActionLabel')}
      className={className}
      layout={ScheduledCashJournalSetupStepContent}
      metaOverrideSet={ScheduledCashJournalOverride}
      LayoutProps={{ resource }}
      onChange={onChange}
      resource={resource}
      onNext={(!hasNext && hasRedirect) ? onNext : undefined}
      onClose={onClose}
    />
  );
};

ScheduledCashJournalSetupStep.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.resource),
};

export default ScheduledCashJournalSetupStep;
